export const inductionQuestions = {
  inductionSession: [
    {
      label: "How would you rate the Induction process overall?",
      name: "inductionRatingOverall",
      options: ["Excellent", "Good", "Fair", "Poor"],
    },
    {
      label:
        "Has your Induction helped you to understand your job, responsibilities, work standard?",
      name: "inductionHelpedUnderstandJob",
      options: ["Yes", "No"],
    },
    {
      label:
        "Were you personally introduced to your new colleagues, managers and during your Induction?",
      name: "introducedToColleagues",
      options: ["Yes", "No"],
    },
    {
      label: "The Induction session helped you to make new friends at work?",
      name: "inductionHelpedMakeFriends",
      options: ["Yes", "No"],
    },
    {
      label: "The topics covered are relevant to your work.",
      name: "topicsRelevantToWork",
      options: ["Yes", "No"],
    },
  ],

  inductionInDepartment: [
    {
      label: "Your manager met you on your first day in the office?",
      name: "managerMetOnFirstDay",
      options: ["Yes", "No"],
    },
    {
      label: "You received warm welcome in office by your colleagues?",
      name: "warmWelcomeByColleagues",
      options: ["Yes", "No"],
    },
    {
      label: "In case any doubts you know who to approach?",
      name: "knowWhoToApproach",
      options: ["Yes", "No"],
    },
    {
      label: "Your job responsibilities were explained to you?",
      name: "jobResponsibilitiesExplained",
      options: ["Yes", "No"],
    },
    {
      label: "Did you find checklist useful?",
      name: "checklistUseful",
      options: ["Yes", "No"],
    },
  ],

  others: [
    {
      label: "You received a tour of the Team1 by a qualified person.",
      name: "receivedOfficeTour",
      options: ["Yes", "No"],
    },
    {
      label:
        "Office hours, dress code, sick leave and other policies were explained to you?",
      name: "policiesExplained",
      options: ["Yes", "No"],
    },
    {
      label: "Payroll policies were covered on your first day?",
      name: "payrollPoliciesCovered",
      options: ["Yes", "No"],
    },
    {
      label:
        "You received a copy of relevant literature such as Team1 Employee Handbook, Company profile etc?",
      name: "receivedLiteratureCopy",
      options: ["Yes", "No"],
    },
    {
      label: "All the necessary paperwork and forms were available.",
      name: "paperworkAvailable",
      options: ["Yes", "No"],
    },
  ],
};
